import { JhiAlertService } from 'ng-jhipster';
import { Subscription } from 'rxjs';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { RequeteDetail, RequeteService, RequeteStatut } from '../../entities/requete';
import { HttpCodeEnum } from '../../shared/constants/http-code.constants';
import { TrackingAction, TrackingCategory } from '../../shared/model/tracking/tracking.enum';
import { TrackingService } from '../../shared/services/tracking.service';
import { Title } from '@angular/platform-browser';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

@Component({
    selector: 'jhi-historique',
    templateUrl: './historique.component.html',
    styleUrls: ['./historique.component.scss']
})
export class HistoriqueComponent implements OnInit, OnDestroy {
    dossier: RequeteDetail;
    isLoading: boolean;
    hasError = false;
    showDossierNonAccessible = false;
    siteJuridictionLabelMsg: string;
    dateAndHour: string[];

    private subscription: Subscription;

    constructor(
        private requeteService: RequeteService,
        private trackingService: TrackingService,
        private route: ActivatedRoute,
        private alertService: JhiAlertService,
        private titleService: Title
    ) {}

    ngOnInit() {
        let dossierId: number;

        this.isLoading = true;
        this.alertService.clear();

        this.subscription = this.route.params.subscribe(params => {
            dossierId = Number(params.id);
            this.requeteService.getRequeteDetail(dossierId).subscribe(
                data => {
                    this.dossier = data;
                    if (this.dossier.statut === RequeteStatut.DOSSIER_NON_ACCESSIBLE) {
                        this.showDossierNonAccessible = true;
                        this.showWarning(this.dossier);
                    }
                    this.titleService.setTitle(`Consultation du dossier (N°${data.numeroRequete})${PAGE_TITLE_SUFFIX}`)
                    this.trackDossier(data.id, TrackingAction.SUCCESS);
                },
                error => {
                    this.processError(dossierId, error);
                    this.hasError = true;
                }
            )
            .add(() => {
                this.isLoading = false;
            });
        });
    }

    displayLoading() {
        return !this.dossier && this.isLoading;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private showWarning(dossier: RequeteDetail): void {
        this.dateAndHour = this.convertModificationDateToDateAndHour(this.dossier.dateModification.toString());
        if (dossier.siteJuridictionLabel.startsWith('Cour')) {
            this.siteJuridictionLabelMsg = 'de la ' + dossier.siteJuridictionLabel;
        } else {
            this.siteJuridictionLabelMsg = 'du ' + dossier.siteJuridictionLabel;
        }
        if (dossier.motif) {
            this.alertService.addAlert({ type: 'warning', msg: 'historique.messages.attachement-remove-motif',
            params: {date: this.dateAndHour[0], hour: this.dateAndHour[1], motif: this.dossier.motif}}, []);
        } else {
            this.alertService.addAlert({ type: 'warning', msg: 'historique.messages.attachement-remove',
            params: {date: this.dateAndHour[0], hour: this.dateAndHour[1]}}, []);
        }

    }

    private convertModificationDateToDateAndHour(dateModification: string): string[] {
        let dateAndHour: string[] = [];
        let date = dateModification.substring(0, dateModification.indexOf('T'));
        date = date.split('-').reverse().join('/');
        dateAndHour.push(date);
        let hour = dateModification.substring(dateModification.indexOf('T') + 1, dateModification.lastIndexOf(':'));
        dateAndHour.push(hour);
        return dateAndHour;
    }

    private processError(dossierId: number, error: any): void {
        if (error.status === HttpCodeEnum.FORBIDDEN) {
            console.log('error | ', error)
            // Forbidden
            this.alertService.addAlert({ type: 'danger', msg: 'historique.error.access-rights' }, []);
        } else {
            this.alertService.addAlert({ type: 'danger', msg: 'historique.error.technical' }, []);
        }

        this.trackDossier(dossierId, TrackingAction.FAILED, error.status);
    }

    private trackDossier(id: number, action: TrackingAction, errorStatus = null) {
        let name =
            errorStatus === HttpCodeEnum.FORBIDDEN ? `Accès refusé, id du dossier : ${id}` : `Id du dossier : ${id}`;

        this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.CONSULTATION_DOSSIER,
                name: name
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/historique-requete/historique.component.ts